import { render, staticRenderFns } from "./TimeSubscriptionsForBeginners.vue?vue&type=template&id=054f0199&scoped=true&"
import script from "./TimeSubscriptionsForBeginners.vue?vue&type=script&lang=js&"
export * from "./TimeSubscriptionsForBeginners.vue?vue&type=script&lang=js&"
import style0 from "./TimeSubscriptionsForBeginners.vue?vue&type=style&index=0&id=054f0199&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054f0199",
  null
  
)

export default component.exports